module.exports = __webpack_public_path__ + "img/checked-radio.eb873eda.svg";